import React from 'react';
import SideMenu from '../Components/SideMenu';
import "antd/dist/antd.css";

const Relatorios = () => {
    return(
        <>
            <SideMenu name='relatorios'>
                <h1>This is the Reports page</h1>
            </SideMenu>
        </>
    )
}

export default Relatorios;